import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import {
  ProSidebar,
  SidebarHeader,
  SidebarFooter,
  SidebarContent,
  Menu,
  MenuItem,
  SubMenu,
} from "react-pro-sidebar";
import "react-pro-sidebar/dist/css/styles.css";
import image from "../../assets/images/logo/noteg_website_logo_2.svg";

const HomeMenu = [
  {
    name: "Ed Tech",
    routerPath: "/ed-tech",
  },
  {
    name: "Change Management",
    routerPath: "/change-management",
  },
  {
    name: "Business Strategy",
    routerPath: "/business-strategy",
  },
  {
    name: "Data Analytics",
    routerPath: "/data-analytics",
  },
  {
    name: "Technology Consulting",
    routerPath: "/Technology-Consulting",
  },
];

const AboutMenu = [
  {
    name: "About Us One",
    routerPath: "/about-Company",
  },
  {
    name: "About Us Two",
    routerPath: "/legal-policy",
  },
];

const ServiceMenu = [
  {
    name: "Service One",
    routerPath: "/our-industries",
  },
  {
    name: "Service Two",
    routerPath: "/Infrastructural-Services",
  },
  {
    name: "Service Details",
    routerPath: "/service-details",
  },
];

const TeamMenu = [
  {
    name: "Team Member",
    routerPath: "/team-member",
  },
  {
    name: "Director",
    routerPath: "/Director",
  },
];

const PortfolioMenu = [
  {
    name: "Portfolio 3 Column",
    routerPath: "/Software-Platform",
  },
  {
    name: "Portfolio 2 Column",
    routerPath: "/Public-Services",
  },
  {
    name: "Portfolio Masonry",
    routerPath: "/Automotive",
  },
  {
    name: "Single Portfolio",
    routerPath: "/Retail",
  },
];

const BlogMenu = [
  {
    name: "About Team",
    routerPath: "/team-member",
  },
  {
    name: "About Company",
    routerPath: "/about-Company",
  },
  // {
  //   name: "Blog Masonry",
  //   routerPath: "/blog-masonry",
  // },
  // {
  //   name: "Blog Standard",
  //   routerPath: "/blog-standard",
  // },
  // {
  //   name: "Blog Details",
  //   routerPath: "/blog-Details",
  // },
];

const MobileMenu = () => {
  const [click, setClick] = useState(false);

  const handleClick = () => {
    setClick(!click);
  };
  return (
    <Fragment>
      <div className="mobile-menu-wrapper">
        <div className="moblie-menu-toggler">
          <button
            className={
              click
                ? "navbar-toggler active d-block d-lg-none"
                : "navbar-toggler d-block d-lg-none"
            }
            type="button"
            onClick={handleClick}
          >
            <span />
          </button>
        </div>
        <ProSidebar className={click ? "mobile-menu menu-open" : "mobile-menu"}>
          <SidebarHeader>
            <div className="mobile-logo">
              <Link to="/">
                <img src={image} alt="" width={130} />
              </Link>
            </div>
            <div className="close-menu" onClick={handleClick}>
              <i className="bi bi-x-lg"></i>
            </div>
          </SidebarHeader>
          <SidebarContent>
            <Menu iconShape="square">
              <MenuItem>
                <Link to="/">Home</Link>
              </MenuItem>
              <SubMenu title="Services">
                {/* <SubMenu title="About Us"> */}
                {HomeMenu.map((val, i) => (
                  <MenuItem key={i}>
                    <Link to={val.routerPath}>{val.name}</Link>
                  </MenuItem>
                ))}
                {/* </SubMenu> */}

                {/* <SubMenu title="Services">
                  {ServiceMenu.map((val, i) => (
                    <MenuItem key={i}>
                      <Link to={val.routerPath}>{val.name}</Link>
                    </MenuItem>
                  ))}
                </SubMenu>

                <SubMenu title="Team">
                  {TeamMenu.map((val, i) => (
                    <MenuItem key={i}>
                      <Link to={val.routerPath}>{val.name}</Link>
                    </MenuItem>
                  ))}
                </SubMenu> */}

                {/* <MenuItem>
                  {""}
                  <Link to="/testimonial">Testimonials</Link>
                </MenuItem> */}

                {/* <MenuItem>
                  {""}
                  <Link to="/price">Our Pricing</Link>
                </MenuItem> */}

                {/* <MenuItem>
                  {""}
                  <Link to="/faq">FAQ</Link>
                </MenuItem> */}

                {/* <MenuItem>
                  {""}
                  <Link to="/error">404 Error</Link>
                </MenuItem> */}
              </SubMenu>

              <MenuItem>
                <Link to="/our-industries">Industries</Link>
              </MenuItem>
              <SubMenu title="About Us">
                {BlogMenu.map((val, i) => (
                  <MenuItem key={i}>
                    <Link to={val.routerPath}>{val.name}</Link>
                  </MenuItem>
                ))}
              </SubMenu>

              <MenuItem>
                {""}
                <Link to="/contact">Contact</Link>
              </MenuItem>
            </Menu>
          </SidebarContent>

          <SidebarFooter></SidebarFooter>
        </ProSidebar>
      </div>
    </Fragment>
  );
};

export default MobileMenu;
